// src/Pages/TermsandConditions.js
import React from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../../Pages/Navbar/JobSeekerNavbar";
import Footer from "../../Footer/Footer";
import { Container } from "react-bootstrap";
import "./TermsandConditions.css"; // optional extra styling

function TermsandConditions() {

    const navigate = useNavigate();

  const handleEmailClick = (e) => {
    e.preventDefault();
    
    // Method 1: Direct mailto link
    const email = "support@gulfworker.net";
    const subject = "Inquiry about Terms & Conditions";
    const body = "Hello Gulfworker Support Team,\n\nI would like to inquire about the following:\n\n";
    
    const mailtoLink = `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    
    // Open the default email client
    window.location.href = mailtoLink;
    
    // Fallback: Open in new tab if needed
    setTimeout(() => {
      window.open(mailtoLink, '_blank');
    }, 500);
  };

    const handleGmailCompose = (e) => {
    e.preventDefault();
    const email = "support@gulfworker.net";
    const subject = encodeURIComponent("Support Request from Gulfworker User");
    const body = encodeURIComponent("Hi Gulfworker Team,\n\nI need help with...");

    // ✅ Open Gmail compose window directly
    const gmailComposeURL = `https://mail.google.com/mail/?view=cm&fs=1&to=${email}&su=${subject}&body=${body}`;
    window.open(gmailComposeURL, "_blank");

     setTimeout(() => {
      navigate("/jobseeker-terms-and-conditions");
    }, 2000); // 2-second delay before redirect


  };

  return (
    <>
      <Navbar />
      <div className="terms-section py-5 mt-5">
        <Container  style={{textAlign:'justify'}}>
          <h1 className="mb-4 text-center fw-bold">
            Terms & Conditions –{" "}
            <a href="https://gulfworker.net" target="_blank" rel="noopener noreferrer">
              Gulfworker.net
            </a>
          </h1>

          <p>
            Welcome to{" "}
            <a href="https://gulfworker.net" target="_blank" rel="noopener noreferrer">
              Gulfworker.net
            </a>{" "}
            ("Website," "Portal," "We," or "Us"). By accessing or using our
            services, you ("User," "Jobseeker," "Employer," or "Manpower Agency")
            agree to comply with and be bound by these Terms & Conditions. If you
            do not agree, please do not use our Website.
          </p>

          <div className="mt-4">
            <h4>1. Form Submission & Agreement</h4>
            <p>
              By Submitting the form, I agree to the Privacy Policy & Terms & Conditions of{" "}
              <strong>Gulfworker.net</strong>. Users must acknowledge and accept
              these terms before registering or using any services on our platform.
            </p>

            <h4>2. Eligibility</h4>
            <ul>
              <li>Users must be at least 18 years old to register or apply for jobs.</li>
              <li>
                By creating an account, you confirm that all information provided
                is true, accurate, and not misleading.
              </li>
            </ul>

            <h4>3. Nature of Service</h4>
            <ul>
              <li>
                <a href="https://gulfworker.net" target="_blank" rel="noopener noreferrer">
                  Gulfworker.net
                </a>{" "}
                is an online job portal connecting Jobseekers, Employers, and
                Manpower Agencies.
              </li>
              <li>Jobseekers may upload profiles, CVs, and contact details.</li>
              <li>
                Employers and Manpower Agencies may post job vacancies and may
                purchase subscriptions to highlight or feature job postings for
                better visibility.
              </li>
              <li>
                Contact details of Jobseekers, Employers, and Manpower Agencies
                may be publicly displayed and visible to all visitors and
                registered users for recruitment purposes.
              </li>
            </ul>

            <h4>4. User Responsibilities</h4>
            <ul>
              <li>Jobseekers must ensure the accuracy and completeness of their CVs and profiles.</li>
              <li>
                Employers and Manpower Agencies must ensure that job postings are
                genuine, accurate, and lawful.
              </li>
              <li>
                Users must not upload or transmit unlawful, fraudulent, offensive,
                or misleading content.
              </li>
            </ul>

            <h4>5. Payment & Subscription</h4>
            <h6>Subscription Fees</h6>
            <ul>
              <li>
                Services such as featured job postings and subscription packages
                are chargeable for Employers and Manpower Agencies.
              </li>
              <li>
                All subscription fees must be paid in advance and are strictly
                non-refundable, except where required by law.
              </li>
              <li>
                Fees are paid solely for the purpose of posting job advertisements
                on{" "}
                <a href="https://gulfworker.net" target="_blank" rel="noopener noreferrer">
                  Gulfworker.net
                </a>
                .
              </li>
            </ul>

            <h6>No Guarantee</h6>
            <p>
              Purchasing a subscription or highlighting a job posting does not
              guarantee applications, responses, interviews, or successful hiring.
            </p>
            <p>
              <a href="https://gulfworker.net" target="_blank" rel="noopener noreferrer">
                Gulfworker.net
              </a>{" "}
              does not guarantee:
            </p>
            <ul>
              <li>The accuracy, qualifications, or reliability of Jobseekers or Employers.</li>
              <li>The suitability of any candidate for a position or of any Employer for a Jobseeker.</li>
            </ul>

            <h6>Dispute Limitation</h6>
            <p>
              In the event of any dispute, complaint, or legal issue — including
              disputes raised by third parties, advocates, or individuals with
              malicious intent —{" "}
              <a href="https://gulfworker.net" target="_blank" rel="noopener noreferrer">
                Gulfworker.net
              </a>
              's maximum liability is strictly limited to the subscription fees
              actually paid by the concerned Employer or Manpower Agency.
            </p>
            <p>
              No claims for damages, compensation, loss of business, or any
              consequential costs shall be entertained.
            </p>

            <h6>Indemnity</h6>
            <p>
              By using{" "}
              <a href="https://gulfworker.net" target="_blank" rel="noopener noreferrer">
                Gulfworker.net
              </a>
              , Employers, Manpower Agencies, and Jobseekers agree to indemnify
              and hold harmless{" "}
              <a href="https://gulfworker.net" target="_blank" rel="noopener noreferrer">
                Gulfworker.net
              </a>
              , its directors, employees, and associates from any and all claims,
              demands, liabilities, damages, or expenses (including legal fees)
              arising out of:
            </p>
            <ul>
              <li>Their use of the platform;</li>
              <li>Their agreements or interactions with one another; or</li>
              <li>Any false, misleading, or harmful information they provide.</li>
            </ul>

            <h6>Limitation of Liability</h6>
            <p>
              Under no circumstances shall{" "}
              <a href="https://gulfworker.net" target="_blank" rel="noopener noreferrer">
                Gulfworker.net
              </a>{" "}
              be liable for:
            </p>
            <ul>
              <li>Any indirect, incidental, special, or consequential damages;</li>
              <li>Loss of profits, opportunities, or reputation;</li>
              <li>
                Claims beyond the subscription fees actually received by{" "}
                <a href="https://gulfworker.net" target="_blank" rel="noopener noreferrer">
                  Gulfworker.net
                </a>
                .
              </li>
            </ul>

            <h4>6. No Recruitment Guarantee</h4>
            <p>
              <a href="https://gulfworker.net" target="_blank" rel="noopener noreferrer">
                Gulfworker.net
              </a>{" "}
              is a platform only and does not act as a recruitment agency or
              guarantee job placements.
            </p>
            <p>Uploading a CV or applying for a job does not assure employment.</p>
            <p>
              Hiring decisions are entirely between Jobseekers, Employers, and
              Manpower Agencies.
            </p>

            <h4>7. Public Display of Information</h4>
            <ul>
              <li>
                By registering, users consent that their contact details (CVs,
                emails, phone numbers, company/agency info) may be publicly visible.
              </li>
              <li>
                <a href="https://gulfworker.net" target="_blank" rel="noopener noreferrer">
                  Gulfworker.net
                </a>{" "}
                is not responsible for how third parties use publicly displayed
                information.
              </li>
              <li>Users should only share information they are comfortable making public.</li>
            </ul>

            <h4>8. Intellectual Property</h4>
            <p>
              All content on{" "}
              <a href="https://gulfworker.net" target="_blank" rel="noopener noreferrer">
                Gulfworker.net
              </a>{" "}
              (logos, text, graphics, design) is owned by{" "}
              <a href="https://gulfworker.net" target="_blank" rel="noopener noreferrer">
                Gulfworker.net
              </a>{" "}
              and may not be copied, reproduced, or distributed without prior
              written consent.
            </p>

            <h4>9. Termination of Accounts</h4>
            <p>
              <a href="https://gulfworker.net" target="_blank" rel="noopener noreferrer">
                Gulfworker.net
              </a>{" "}
              reserves the right to suspend or terminate accounts that violate
              these Terms or engage in fraudulent, unlawful, or misleading
              activity, without prior notice.
            </p>

            <h4>10. Amendments</h4>
            <p>
              <a href="https://gulfworker.net" target="_blank" rel="noopener noreferrer">
                Gulfworker.net
              </a>{" "}
              may update or modify these Terms & Conditions at any time. Updates
              become effective once published on the Website. Continued use of
              the Website constitutes acceptance of updated Terms.
            </p>

            <h4>11. Governing Law</h4>
            <p>
              These Terms shall be governed by and construed in accordance with
              the laws of [Insert Applicable Jurisdiction, e.g., India / UAE].
            </p>
            <p>
              Any disputes arising under these Terms shall be subject to the
              exclusive jurisdiction of the courts in [Mumbai/India].
            </p>

             <h4>12. Contact Us</h4>
            <p>
              For questions, concerns, or complaints regarding these Terms,
              please contact:
              <br />
              📧 Email:{" "}
              <a href="#" onClick={handleGmailCompose}>
                support@gulfworker.net
              </a>
            </p>

          </div>
        </Container>
      </div>
      <Footer />
    </>
  );
}

export default TermsandConditions;